import { render, staticRenderFns } from "./othersIndustry.vue?vue&type=template&id=060e5914"
import script from "./othersIndustry.vue?vue&type=script&lang=js"
export * from "./othersIndustry.vue?vue&type=script&lang=js"
import style0 from "./othersIndustry.vue?vue&type=style&index=0&id=060e5914&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports